import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft, Info } from 'lucide-react';
import { AuthLayout } from '@/components/AuthLayout';
import { Button } from '@/components/ui/button';

// The Worker has no endpoint that completes a reset from an emailed link, so this page
// says so instead of presenting a form that cannot succeed.
function ResetPassword() {
  const { t } = useTranslation();
  return (
    <AuthLayout>
      <Link to="/login" className="text-link text-sm">
        <ArrowLeft className="od-icon" />
        {t('auth.backToSignIn', { defaultValue: 'Back to sign in' })}
      </Link>
      <p className="page-eyebrow">{t('auth.accountAssistance', { defaultValue: 'Account assistance' })}</p>
      <h1>{t('auth.resetUnavailableTitle', { defaultValue: 'Reset link' })}</h1>
      <div className="request-notice !mx-0 mt-6">
        <Info className="od-icon" />
        <span>
          {t('auth.resetUnavailable', {
            defaultValue:
              'Password reset cannot be completed from this page. Contact your organization administrator to complete an invitation or reset your password. Your link has not been submitted.',
          })}
        </span>
      </div>
      <Button asChild className="mt-6 w-full">
        <Link to="/login">{t('auth.returnToSignIn', { defaultValue: 'Return to sign in' })}</Link>
      </Button>
    </AuthLayout>
  );
}

export default ResetPassword;
